export const pieChartPageTwoList = [
  // {
  //   title: "VFL Area wise - Scheduled",
  //   value: "vflStatusAreaWiseSCheduledChart",
  // },

  {
    title: "VFL Completed - By Area",
    value: "vflStatusAreaWiseCompletedChart",
    isScroll: true,
  },

  {
    title: "VFL Overdue - By Area",
    value: "vflStatusAreaWiseOverDueChart",
    isScroll: true,
  },

  {
    title: "VFL Completed - Top 5 Executives",
    value: "topFiveVFLExecutivesChart",
  },
  {
    title: "VFL Overdue - Top 5 Executives",
    value: "topFiveVFLExecutivesOverDueChart",
  },
  // {
  //   title: "Top 5 VFL Areas",
  //   value: "TopVFLStatusAreaWiseChart",
  // },
];

export const optionsList = [
  { screen: 1, name: "screen1" },
  { screen: 2, name: "screen2" },
];

export const stackAndBarPageOneList = [
  {
    name: " VFL Status - All Locations",
    yAxisName: "Count",
    xAxisName: "Site",
    value: "vflScheduledHOChart",
    type: "barWithLabel",
    isRO: false,
    isHo: false,
  },
  {
    name: "VFL Status - Head Office Only",
    yAxisName: "Count",
    xAxisName: "Site",
    value: "vflCompletedHOChart",
    type: "barWithLabel",
    isRO: false,
    isHo: true,
  },

  {
    title: "Outstanding CAPAs - All Locations",
    value: "vflOutStandingCAPAsHOChart",
    type: "pie",
    isRO: false,
    isHo: false,
  },
  {
    title: "Outstanding CAPAs - Head Office Only",
    value: "vflOverDueHOChart",
    type: "pie",
    isRO: false,
    isHo: true,
  },
  {
    title: "OverDue CAPAs - All Locations",
    value: "vflOverdueCAPAsHOChart",
    type: "pie",
    isRO: false,
    isHo: false,
  },
  {
    title: "OverDue CAPAs - Head Office Only",
    value: "vflOverDueCAPAsHeadOfficeOnly",
    type: "pie",
    isRO: false,
    isHo: true,
  },
  // {
  //   name: "VFL Scheduled - RO",
  //   yAxisName: "Count",
  //   xAxisName: "Site",
  //   value: "vflScheduledROChart",
  //   type: "barWithLabel",
  //   isRO: true,
  // },
  // {
  //   name: "VFL Completed - RO",
  //   yAxisName: "%",
  //   xAxisName: "Site",
  //   value: "vflCompletedROChart",
  //   type: "barWithLabel",
  //   toolTip: ["completed", "scheduled"],
  //   isRO: true,
  // },
  {
    name: "VFL Performance - Regional Offices",
    yAxisName: "%",
    xAxisName: "Site",
    value: "vflCompletedROChart",
    type: "barWithLabelAndCustomToolTip",
    toolTip: ["mineFullName", "completed", "scheduled"],
    isRO: true,
    isHo: true,
  },
  {
    name: "VFL Overdue - Regional Offices",
    yAxisName: "Count",
    xAxisName: "Site",
    value: "vflOverDueROChart",
    customeTool: true,
    type: "barWithLabel",
    isRO: true,
    isHo: true,
  },
  {
    name: "CAPA Status - Regional Offices",
    yAxisName: "Count",
    xAxisName: "",
    value: "vflOutStandingCAPAsRoChart",
    type: "stack",
    isRO: true,
    isMines: true,
    isHo: true,
  },
  // {
  //   name: "CAPAs Overddue - RO",
  //   yAxisName: "Count",
  //   xAxisName: "Site",
  //   value: "vflOverdueCAPAsRoChart",
  //   type: "barWithLabel",
  //   isRO: true,
  // },
  // {
  //   name: "VFL Scheduled - Mine",
  //   yAxisName: "Count",
  //   xAxisName: "Site",
  //   value: "vflScheduledMinesChart",
  //   type: "barWithLabel",
  //   isRO: true,
  // },
  {
    name: "VFL Performance - Mines",
    yAxisName: "%",
    xAxisName: "",
    value: "vflCompletedMinesChart",
    type: "barWithLabelAndCustomToolTip",
    toolTip: ["mineFullName", "completed", "scheduled"],
    isRO: true,
    isMines: true,
    isHo: false,
  },
  {
    name: "VFL Overdue - Mine",
    yAxisName: "Count",
    xAxisName: "",
    value: "vflOverDueMinesChart",
    type: "barWithLabel",
    isRO: true,
    customeTool: true,
    isMines: true,
    isHo: false,
  },
  {
    name: "CAPAs Outstanding - Mines",
    yAxisName: "Count",
    xAxisName: "",
    value: "vflOutStandingCAPAsMinesChart",
    type: "barWithLabel",
    isRO: true,
    customeTool: true,
    isMines: true,
    isHo: false,
  },
  // {
  //   name: "CAPAs Overddue - Mines",
  //   yAxisName: "Count",
  //   xAxisName: "Site",
  //   value: "vflOverdueCAPAsMinesChart",
  //   type: "barWithLabel",
  //   isRO: true,
  // },
];
export const stackAndBarPageTwoList = [
  {
    name: "VFL Completed - Last 12 months",
    yAxisName: "Count",
    xAxisName: "",
    value: "last12MonthsChart",
    type: "barWithLabelMonth",
    isMines: true,
  },
];
